import * as actionTypes from 'containers/AccessControl/actionTypes';
import { HamburgerMenuType } from 'utils/types';
import { AuthSession } from '@spins/react-sso-provider';

export const initApp = (authSession: AuthSession, client: any, history: any) => ({
  type: actionTypes.APP_INIT,
  payload: { authSession, history, client }
});

export const setHamburgerMenuItems = (value: Array<HamburgerMenuType>) => ({
  type: actionTypes.HAMBURGER_MENU_ITEMS_SET,
  payload: value
});

export const setPeriodDate = (spins, nielsen) => ({
  type: actionTypes.PERIOD_DATE_SET,
  payload: { spins, nielsen }
});
